<template>
  <div>
    <el-table :data="tickers">
      <el-table-column prop="symbolKey" label="货币ID"></el-table-column>
      <el-table-column prop="symbolName" label="货币全称"></el-table-column>
      <el-table-column prop="anchorKey" label="锚定货币ID"></el-table-column>
      <el-table-column prop="anchorName" label="锚定货币名称"></el-table-column>
      <el-table-column prop="price" label="最新成交价格"></el-table-column>
      <el-table-column prop="priceUpdatedAt" label="价格最后更新时间">
        <template slot-scope="scope">
          {{ scope.row.priceUpdatedAt | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="volume24h" label="24小时成交价"></el-table-column>
      <el-table-column
        prop="volume24h"
        label="24小时锚定货币成交额"
      ></el-table-column>

      <!-- <el-table-column prop="createTime" label="时间">
        <template slot-scope="scope">
            {{scope.row.createTime | moment}}
        </template>
              </el-table-column>
              <el-table-column prop="__status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">
            {{scope.row.__status.text}}
          </el-tag>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'MyTokenTickerList',
  computed: {
    ...mapState('myTokenTicker', ['tickers'])
  }
};
</script>

<style lang="less" scoped></style>
